import React from 'react';
import MediumTypography from '../../components/formlib/MediumTypography';
import { Box } from '@mui/system';
import { IfspReviewItem } from './IFSPReviewScreen';
import { TableCell, TableRow } from '@mui/material';
import ToolTipIcon from '../../components/formlib/ToolTipIcon';
import { ReactComponent as ViewEye } from '../../assets/images/ViewEye.svg';
import dayjs from 'dayjs';
import moment from 'moment';

type IFSPReviewListRowType = {
  data: IfspReviewItem;
  serviceCoordinator: string;
  onViewClick: (rowData: IfspReviewItem) => void;
};

const IFSPReviewListRow = ({
  data,
  serviceCoordinator,
  onViewClick,
}: IFSPReviewListRowType) => {
  return (
    <TableRow
      hover
      sx={{
        cursor: 'pointer',
        alignContent: 'flex-start',
        '&:nth-of-type(odd)': {
          backgroundColor: '#ECF9F8',
        },
      }}
    >
      <TableCell>
        {data.name ? (
          <MediumTypography label={data.name} sxProps={{ textAlign: 'left' }} />
        ) : (
          <MediumTypography label="-" sxProps={{ textAlign: 'left' }} />
        )}
      </TableCell>
      <TableCell>
        {data.enrollmentNumber ? (
          <MediumTypography
            label={data.enrollmentNumber}
            sxProps={{ textAlign: 'left' }}
          />
        ) : (
          <MediumTypography label="-" sxProps={{ textAlign: 'left' }} />
        )}
      </TableCell>
      <TableCell>
        {data.ifspFirstMeetingDate ? (
          <MediumTypography
            label={data.ifspFirstMeetingDate}
            sxProps={{ textAlign: 'left' }}
          />
        ) : (
          <MediumTypography label="-" sxProps={{ textAlign: 'left' }} />
        )}
      </TableCell>
      <TableCell>
        {serviceCoordinator ? (
          <MediumTypography
            label={serviceCoordinator}
            sxProps={{ textAlign: 'left' }}
          />
        ) : (
          <MediumTypography label="-" sxProps={{ textAlign: 'left' }} />
        )}
      </TableCell>
      <TableCell>
        {data.emrUpdatedOn ? (
          <MediumTypography
            label={moment
              .utc(data.emrUpdatedOn)
              .local()
              .format('MM/DD/YYYY hh:mm A')}
            sxProps={{ textAlign: 'left' }}
          />
        ) : (
          <MediumTypography label="-" sxProps={{ textAlign: 'left' }} />
        )}
      </TableCell>
      <TableCell>
        {data.emrUpdatedOn ? (
          <Box display="flex" flexDirection="column">
            <Box display="flex" alignItems="center">
              <MediumTypography
                label={(() => {
                  const days = dayjs().diff(
                    dayjs.utc(data.emrUpdatedOn).local(),
                    'day',
                  );
                  return `${days}`;
                })()}
                sxProps={{
                  textAlign: 'left',
                  padding: '2px 12px',
                  borderRadius: '12px',
                  backgroundColor:
                    dayjs().diff(dayjs.utc(data.emrUpdatedOn).local(), 'day') >=
                    14
                      ? '#FDE7EA'
                      : 'default',
                }}
                textColor={
                  dayjs().diff(dayjs.utc(data.emrUpdatedOn).local(), 'day') >=
                  14
                    ? '#EB4C60'
                    : 'default'
                }
                fontweight={
                  dayjs().diff(dayjs.utc(data.emrUpdatedOn).local(), 'day') >=
                  14
                    ? 700
                    : 500
                }
              />
            </Box>
          </Box>
        ) : (
          <MediumTypography label="-" sxProps={{ textAlign: 'left' }} />
        )}
      </TableCell>
      <TableCell>
        <Box className="flex__">
          <Box
            className="cursorPointer"
            onClick={() => {
              if (onViewClick) {
                onViewClick(data);
              }
            }}
          >
            <ToolTipIcon
              labelId="ConsentForms.listActionViewToolTipLabel"
              defaultLabel="View"
              cursor="pointer"
              Icon={<ViewEye />}
            />
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default IFSPReviewListRow;
